<template>
<loader v-bind="{ loading }">
  <page-navigation :title="app.name">
    <template #right>
      <router-link class="button" :to="{ name: 'app-settings', params: $route.params}">
        <icon icon="cog"/>
      </router-link>
    </template>
  </page-navigation> 
  <div class="tabs">
    <ul>
      <router-link exact tag="li" :to="{ name: 'app-manager', params: { app: $route.params.app }}">
        <a>Overview</a>
      </router-link>
      <router-link tag="li" :to="{ name: 'app-audits', params: { app: $route.params.app }}">
        <a>Audits</a>
      </router-link>
      <router-link tag="li" :to="{ name: 'app-environments', params: { app: $route.params.app }}">
        <a>Environments ({{ app.environments_count }})</a>
      </router-link>
      <router-link tag="li" :to="{ name: 'app-environments', params: { app: $route.params.app }}">
        <a>Reporting</a>
      </router-link>
      <router-link tag="li" :to="{ name: 'app-team', params: { app: $route.params.app }}">
        <a>Team</a>
      </router-link>
    </ul>
  </div>
  <router-view />
</loader>
</template>

<script>
import { mapGetters } from 'vuex'

export default {

  data: () => ({
    loading: true
  }),

  beforeCreate() {
    this.$bus.$emit('set-title', 'App Manager')
  },

  created() {
    this.$store.dispatch('app/loadApp', this.$route.params.app).then(() => {
      this.$bus.$emit('set-title', `${this.app.name}`)
      if(this.app.team_id) {
        this.$store.dispatch('app/loadUserPermissions').then(() => {
          this.loading = false
        })
      } else {
        this.loading = false
      }
    })
  },

  computed: {
    ...mapGetters('app', [
      'app'
    ])
  }
}
</script>
